import React from 'react';
import { SHAPE_LINEAR } from './constants';
import Linear, { ILinear } from './linear';

const SHAPES_COMPONENT_MAP: {
    [key: string]: ({ style }: ILinear) => JSX.Element;
} = {
    [SHAPE_LINEAR]: Linear,
};

interface IProgressIndicator {
    shape?: string;
    style: 'dark' | 'light' | 'gradient';
}

const ProgressIndicator = ({
    shape = SHAPE_LINEAR,
    style,
}: IProgressIndicator) => {
    const ProgressIndicatorShape = SHAPES_COMPONENT_MAP[shape] || Linear;

    return (
        <div>
            <ProgressIndicatorShape style={style} />
        </div>
    );
};

export default ProgressIndicator;
